import {Component, computed, inject} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RouterLink} from '@angular/router';
import {GroupVoucherService} from '@core/services/groupVoucher.service';

@Component({
  selector: 'app-product-not-in-group-voucher-modal',
  templateUrl: './product-not-in-group-voucher-modal.component.html',
  imports: [ModalContainerComponent, RouterLink]
})
export class ProductNotInGroupVoucherModalComponent {
  private activeModal = inject(NgbActiveModal);
  private groupVoucherService = inject(GroupVoucherService);

  readonly voucherListPath = computed(() => {
    const wrapper = this.groupVoucherService.groupVoucherSignal();
    if (wrapper.isCustomerLinked) {
      return '/kundeportal/udvalgt-sortiment';
    }
    return wrapper.groupVoucher?.redirectTo || '/voucher/list';
  });

  close() {
    this.activeModal.close();
  }
}
